import getCurrencySymbol from 'currency-symbols';

export const currencySymbol = currency =>
  getCurrencySymbol(currency) || currency;
